import OktaSignIn from "@okta/okta-signin-widget";
import {getSiteConfig} from "../config";


/**
 * Returns the Okta Widget Configuration
 */
export const getOktaConfig = () => {
    //
    // AbbVie Okta use Classic Engine.
    //
    return {
        clientId: getSiteConfig().OKTA_CLIENT_ID,
        issuer: getSiteConfig().OKTA_ISSUER,
        redirectUri: getSiteConfig().OKTA_REDIRECT_URI,

        scopes: ["openid", "profile", "email", "offline_access"],
        //pkce: true,
        //disableHttpsCheck: true,
        useClassicEngine: true,
        useInteractionCodeFlow: false,
        requestType: "code",
    };
}


export const isCorsError = (err) => (err.name === 'AuthApiError' && !err.statusCode);


/**
 * Okta logout.
 */
export const oktaLogout = async (forceReload, params, urlOverride) => {

    const oktaConfig = getOktaConfig();

    const oktaSignIn = new OktaSignIn(oktaConfig);

    //
    // Clear existing access-tokens.
    //
    await oktaSignIn.authClient.revokeAccessToken();

    //
    // Close the session...
    //
    oktaSignIn.authClient.closeSession()
        .then((sessionClosed) => {

            console.log("Okta session closed.",sessionClosed);

            // if (sessionClosed) {
            //     //window.location.reload(); // optional
            // } else {
            //     // Session does not exist or has already been closed
            // }
        })
        .catch(e => {
            console.log("Failed to close Okta session.",e);

            // if (e.xhr && e.xhr.status === 429) {
            //     // Too many requests
            // }

        }).finally(()=>{
            if(forceReload){

                let url = urlOverride?urlOverride:"/";

                if(params){
                    url = `${url}?${params}`;
                }
                window.location=url;
            }
    });
}
